import React from "react";
import Login from '../Components/Login/login'

const LoginPage = ()=> (
    <div>
        <Login/>
    </div>
)

export default LoginPage;